<div fxFlex="40px" class="loading-value" fxLayout="row wrap" fxLayoutAlign="center">
  <div class="dot-pulse"></div>
</div>
